import { webEventEmitter } from '@/utils/Bridge/eventEmitter';

export interface ScreenSizeChangeResp {
  channelId: string; // 会议房间ID
  sourceWidth: number; // 屏幕宽度
  sourceHeight: number; // 屏幕高度
}
export default function useScreenSizeChange() {
  const change = async (body: ScreenSizeChangeResp) => {
    if (isMobile) {
      return;
    }

    if (body.sourceWidth && body.sourceHeight) {
      webEventEmitter.emit('captureSourceChanged', {
        width: body.sourceWidth,
        height: body.sourceHeight,
      });
    }
  };
  return change;
}
